export interface AreaCodeActionTypes {
  type: AreaCodeActions;
  payload?: any;
}

export enum AreaCodeActions {
  CREATE_AREA_CODE = "CREATE_AREA_CODE",
  GET_AREA_CODE_LIST = "GET_AREA_CODE_LIST",
  SET_AREA_CODE_LIST = "SET_AREA_CODE_LIST",
  SET_AREA_CODE_LIST_PAGE_COUNT = "SET_AREA_CODE_LIST_PAGE_COUNT",
  GET_AREA_CODE_DATA_BY_ID = "GET_AREA_CODE_DATA_BY_ID",
  SET_AREA_CODE_DATA_BY_ID = "SET_AREA_CODE_DATA_BY_ID",
  EDIT_AREA_CODE_DATA_BY_ID = "EDIT_AREA_CODE_DATA_BY_ID",
  DELETE_AREA_CODE = "DELETE_AREA_CODE",
}
